import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type Settle = {
  id: string;
  managerEmail: string;
  managerName?: string;
  name?: string;
  test: boolean;
  isTest: boolean;
  useCi: boolean;
};

export const getSettleList = (serviceId: string) => {
  return api<PcApiResponse<Settle[]>>('get', `/pc-api/v1/${PREFIX_PATH}/settle/list`, { serviceId });
};
